import React from 'react'
import { Trans } from '@lingui/macro'
import { UserSecurityQuestionsEnum } from 'shared/enums/UserSecurityQuestionsEnum'

export const ReadableSecurityQuestionsEnum: Record<
  UserSecurityQuestionsEnum,
  string
> = {
  [UserSecurityQuestionsEnum.MOTHER_MAIDEN_NAME]:
    "What is your mother's maiden name?",
  [UserSecurityQuestionsEnum.CHILDHOOD_NICKNAME]:
    'What was your childhood nickname?',
  [UserSecurityQuestionsEnum.OLDEST_SIBLING_MIDDLE_NAME]:
    "What is your oldest sibling's middle name?",
  [UserSecurityQuestionsEnum.FIRST_JOB_TOWN]:
    'In what city or town was your first job?',
  [UserSecurityQuestionsEnum.CHILD_DREAM_JOB]:
    'What was your dream job as a child?',
  [UserSecurityQuestionsEnum.GRANDMOTHERS_FIRST_NAME]:
    "What is your grandmother's first name?",
  [UserSecurityQuestionsEnum.FAVOURITE_MOVIE]: 'What is your favourite movie?',
  [UserSecurityQuestionsEnum.FAVOURITE_PET_NAME]:
    "What is your favourite pet's name?",
  [UserSecurityQuestionsEnum.FIRST_PHONE_MODEL]:
    'What is the first phone model you owned?',
  [UserSecurityQuestionsEnum.FAVOURITE_PIZZA_TOPPING]:
    'What is your favourite pizza topping?'
}

export const forbiddenQuestionsTranslations = new Set(
  Object.values(ReadableSecurityQuestionsEnum)
)
/**
 * BE CAREFUL!!!
 * DO NOT EDIT **label** W/O EDITING ENUM ReadableSecurityQuestionsEnum
 */
export const QUESTIONS_OPTIONS = [
  {
    value: 'NOT_SELECTED',
    label: <Trans>Not selected</Trans>
  },
  {
    value: UserSecurityQuestionsEnum.MOTHER_MAIDEN_NAME,
    label: <Trans>What is your mother's maiden name?</Trans>
  },
  {
    value: UserSecurityQuestionsEnum.CHILDHOOD_NICKNAME,
    label: <Trans>What was your childhood nickname?</Trans>
  },
  {
    value: UserSecurityQuestionsEnum.OLDEST_SIBLING_MIDDLE_NAME,
    label: <Trans>What is your oldest sibling's middle name?</Trans>
  },
  {
    value: UserSecurityQuestionsEnum.FIRST_JOB_TOWN,
    label: <Trans>In what city or town was your first job?</Trans>
  },
  {
    value: UserSecurityQuestionsEnum.CHILD_DREAM_JOB,
    label: <Trans>What was your dream job as a child?</Trans>
  },
  {
    value: UserSecurityQuestionsEnum.GRANDMOTHERS_FIRST_NAME,
    label: <Trans>What is your grandmother's first name?</Trans>
  },
  {
    value: UserSecurityQuestionsEnum.FAVOURITE_MOVIE,
    label: <Trans>What is your favourite movie?</Trans>
  },
  {
    value: UserSecurityQuestionsEnum.FAVOURITE_PET_NAME,
    label: <Trans>What is your favourite pet's name?</Trans>
  },
  {
    value: UserSecurityQuestionsEnum.FIRST_PHONE_MODEL,
    label: <Trans>What is the first phone model you owned?</Trans>
  },
  {
    value: UserSecurityQuestionsEnum.FAVOURITE_PIZZA_TOPPING,
    label: <Trans>What is your favourite pizza topping?</Trans>
  }
]

export const defaultSecurityOptionValue = {
  question: QUESTIONS_OPTIONS[0].value,
  answer: ''
}
